import axiosInstance from "../axiosInstance";

export const catalogAnalyticsService = {
  /**
   * Fetch catalog analytics data.
   *
   * @param {Object} filters
   * @param {string|null} filters.client_id
   * @param {string|null} filters.start_date  ISO string
   * @param {string|null} filters.end_date    ISO string
   * @param {string|null} filters.catalog_uid  specific catalog edition uid
   * @param {number|null} filters.page         page number within catalog
   * @param {string|null} filters.style_sku    specific SKU
   *
   * @returns {{ revenueChart: Array, catalogMetrics: Array, filters: Object }}
   */
  fetch: async (filters = {}) => {
    try {
      const response = await axiosInstance.post("/catalog-analytics", filters);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
